import { render, staticRenderFns } from "./ProductMassUpdate.vue?vue&type=template&id=115d2b34"
import script from "./ProductMassUpdate.vue?vue&type=script&lang=js"
export * from "./ProductMassUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProductMassUpdate.vue?vue&type=style&index=0&id=115d2b34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports